<template>
  <div class="col-6 col-sm-6 col-lg-3 gird_product one_product_grid">
    <div class="card border-0 position-relative">
      <img @click="$router.push({
        name: 'product',
        params: {
          storeName: $store.storeName,
          id: productid,
          name: name,
          lang: $i18n.locale
        },
      });" :src="image" class="card-img-top grid_product_img" :alt="name">
      <!-- أيقونات عائمة -->
      <div class="div_button_list position-absolute top-0 end-0 p-2 d-flex flex-column gap-2 ">
        <button v-if="this.$localStorage.get(this.$store.storeName) != null"
          class="btn btn-light rounded-circle shadow-sm product_list_button " @click="changeFav">
          <i v-if="this.fav" class="fa fa-heart" style="color:red"></i>
          <i v-else class="fa fa-heart"></i>
        </button>

        <button v-if="(!is_option) && qnt != 0 && loading_add == false && (!jellwery[0])"
          class="btn btn-light rounded-circle shadow-sm product_list_button" @click="addToCart">
          <i class="fa fa-shopping-cart"></i>
        </button>
        <!-- class="fa fa-spinner fa-spin icon_loading"  -->
        <button v-if="loading_add == true" class="btn btn-light rounded-circle shadow-sm product_list_button"
          style="display:block">
          <i class="fa fa-spinner fa-spin icon_loading"></i>
        </button>


      </div>
      <div v-if="jellwery[0]" class="div_button_list position-absolute top-0 start-0 p-2 d-flex flex-column gap-2 ">
        <button :class="'btn btn-light rounded-circle shadow-sm metrial_type_label ' + jellwery[0].type"
          style="display:block;color:black">
          {{ $t(jellwery[0].type) }}( {{ jellwery[0].purity }} k)
        </button>
      </div>
      <div @click="$router.push({
        name: 'product',
        params: {
          storeName: $store.storeName,
          id: productid,
          name: name,
          lang: $i18n.locale
        },
      });" class="card-body">
        <h6 class="card-title">{{ name.substr(0, 25) }}</h6>
        <p class="card-text">
        <div v-if="jellwery[0]" class="flex justify-between items-center mt-1">

          <p>{{ (calculateJewelryPrice()).toFixed(2) }} {{ $store.state.UnitPrice }}
            <span class="count_gram">({{ jellwery[0].count_gram }} {{ $t('gram') }} / {{ jellwery[0].purity }} k)</span>
          </p>


        </div>
        <div v-else class="flex justify-between items-center mt-1">
          <p v-if="is_option && range_price">
            {{ range_price.min_price * this.$store.state.rate }}{{ this.$store.state.UnitPrice }} _ {{ range_price.max_price
              * this.$store.state.rate}}{{ this.$store.state.UnitPrice }}</p>
          <p v-else-if="is_option">{{ $t('PriceOnRequest') }}</p>
          <p v-else-if="(new_price > 0) && (!is_option)">{{
            (new_price * this.$store.state.rate).toFixed($store.state.digit_price) }}{{ this.$store.state.UnitPrice }}
            <del class="text-slate-400">{{ old_price.toFixed($store.state.digit_price)
              * this.$store.state.rate}}{{ this.$store.state.UnitPrice }}</del>
          </p>



          <p v-else-if="!is_option">{{ old_price.toFixed($store.state.digit_price) * this.$store.state.rate }}
            {{ this.$store.state.UnitPrice }}</p>

        </div>

        </p>
      </div>
    </div>

    <div v-if="validateMessage != ''" class="validate_message">
      <div style="display: flex; align-items: center;">
        <img v-if="image" :src="image" alt="Product"
          style="width: 60px; height: 60px; border-radius: 8px; object-fit: cover; margin-right: 10px;">
        <div style="text-align: left;">
          <p style="margin: 0;font-weight: 450;">{{ $t('Qty') }}: 1</p>
          <p style="margin-top: 10px;font-weight: 450;">{{ $t('Added Cart Successfully') }}</p>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  props: {
    qnt: Number,
    min_qnt: Number,
    max_qnt: Number,
    name: String,
    description: String,
    is_favorit: Boolean,
    is_option: Number,
    image: String,
    old_price: Number,
    new_price: Number,
    productid: Number,
    count_view: Number,
    unit: String,
    rate: Number,
    is_offer: Boolean,
    discount: Number,
    new: Boolean,
    fetuered: Boolean,
    note: String,
    range_price: Object,
    jellwery: {
      type: [Object, Array],
      default: () => ([]),
    },


  },
  data: function () {
    return {
      login: false,
      fav: false,
      loginMassage: null,
      show: false,
      validateMessage: '',
      finalOptions: 0,
      msg_fav: null,
      loading_add: false,
      price_jellwery: 0.00
    };
  },

  methods: {
    changeFav() {
      if (this.$localStorage.get(this.$store.storeName) == null) {
        this.login = true;
      }
      setTimeout(() => {
        // this.updateall();
        this.login = false;
      }, 3000);
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/favourite_product_change/" +
          this.productid,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.fav = !this.fav;
            this.msg_fav = response.data.message
            setTimeout(() => {
              // this.updateall();
              this.msg_fav = null;
            }, 3000);


          }
          else {
            this.msg_fav = response.data.message
            setTimeout(() => {
              // this.updateall();
              this.msg_fav = null;
            }, 3000);
          }
        });
    },
    ////{ path: `/user/${id}` }
    productRoute() {
      if (this.$route.path.includes("/product")) {
        this.$router.push({
          name: "product",
          params: { id: this.productid, name: this.name, lang: this.$i18n.locale },
        });
      } else {
        this.$router.push({
          name: "product",
          params: {
            storeName: this.$store.storeName,
            id: this.productid,
            name: this.name,
            lang: this.$i18n.locale,
          },
        });
      }
    },

    addToCart() {
      console.log('%%%%%');
      var checked_true = [];
      this.loading_add = true;
      this.axios
        .post(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/check_cart_item",
          {
            product_id: this.productid,
            total_price: this.old_price,
            offer_price: this.new_price,
            quantity: 1,
            old_qnt: 0,
            final_option: 0,
            option_check: [],
            jellwery: this.jellwery,
            product_metal_id: this.jellwery[0] ? this.jellwery[0].id : null,
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          let product = null;
          this.validateMessage = response.data.message;
          setTimeout(() => {
            // this.updateall();
            this.validateMessage = "";
          }, 3000);

          if (response.data.code == "1") {
            this.loading_add = false;
            // let products = new Map;
            let S_name1 =
              this.$store.storeName +
              "/" +
              this.productid +
              '0' +
              checked_true;
            if (this.$cookies.isKey(S_name1)) {
              /*console.log(
                "this.price " +
                  this.price +
                  "this.$cookies.get( S_name1 ).total_price" +
                  this.$cookies.get(S_name1).total_price
              );*/
              product = {
                product_id: this.productid,
                total_price:
                  this.price + this.$cookies.get(S_name1).total_price,
                offer_price:
                  this.offer_price + this.$cookies.get(S_name1).offer_price,
                quantity: Number(1) + Number(this.$cookies.get(S_name1).quantity),
                quantityAll: this.$cookies.get(S_name1).quantityAll,
                max_quantity: this.$cookies.get(S_name1).max_quantity,
                min_quantity: this.$cookies.get(S_name1).min_quantity,
                final_option: 0,
                option_check: checked_true,
                discount: this.discount,//this.DBitems.product.discount,
                note: this.$cookies.get(S_name1).note
              };
            } else {
              this.loading_add = false;
              console.log("hlooooooooooo ::::::::; " + this.qnt);
              product = {
                product_id: this.productid,
                total_price: this.old_price,
                offer_price: this.new_price,
                quantity: Number(1),
                quantityAll: this.qnt,
                min_quantity: this.min_qnt,
                max_quantity: this.max_qnt,
                final_option: 0,
                option_check: checked_true,
                discount: this.discount,
                note: ''
              };
            }

            let S_name = this.$store.storeName + "/";

            if (
              !this.$cookies.isKey(
                S_name +
                product.product_id +
                product.final_option +
                product.option_check
              )
            ) {
              this.$store.state.cartCounter = this.$store.state.cartCounter + 1;
            }

            this.$cookies.set(
              S_name +
              product.product_id +
              product.final_option +
              product.option_check,
              product
            );
          }
          /*this.$router.push({
            name: "shoppingCart",
            params: {
              storeName: this.$store.storeName,
            },
          });*/

          this.$store.state.update_cart_list = true;

          setTimeout(() => {
            // this.updateall();
            this.validateMessage = "";
          }, 3000);
        });
    },
    calculateJewelryPrice() {
      if (!this.jellwery || !Array.isArray(this.jellwery)) return 0;

      let totalPrice = 0;

      this.jellwery.forEach(item => {
        const manufacturingCost = Number(item.gold_manufacturing || 0); // المصنعية
        const gramCount = Number(item.count_gram || 1); // عدد الغرام
        // const pricePerGram = Number(item.price || 0); // السعر لكل غرام
        let purityFactor = item.purity / 24;
        // حسب النوع (gold / silver)
        let typeMultiplier = 1;
        if (item.type === "gold") {
          typeMultiplier = (this.$store.state.gold.qar_ask) * purityFactor; // يمكن تعديل إذا أردت زيادة سعر الذهب عن الفضّة
        } else if (item.type === "silver") {
          typeMultiplier = (this.$store.state.silver.qar_ask) * purityFactor; // يمكن تعديل إذا أردت سعر مختلف للفضة
        }

        totalPrice += (gramCount * (typeMultiplier + manufacturingCost));
      });

      return totalPrice;
    }
  },
};
</script>
